import { createFileRoute } from '@tanstack/react-router';
import { Stack } from '@osd/ui/stack';
import {
  AccountCard,
  ApiStatusFooter,
  GreetingHeader,
  NeedsAttention,
  QuickNav,
} from '../features/home/components';

/**
 * / — Home page (root/osd#42, #46).
 *
 * Thin glue page that assembles the home widgets in the order
 * recommended by the epic:
 *   1. GreetingHeader      — identify the user (everyone sees this)
 *   2. NeedsAttention      — admin-only; pending approvals + audit
 *   3. AccountCard         — email + role
 *   4. QuickNav            — grid of go-to-page tiles
 *   5. ApiStatusFooter     — tiny reachability indicator
 *
 * Per AGENTS.md / folder-architecture.instructions.md the
 * individual widgets live under features/home/components/. This
 * file stays thin (<50 LOC) so the dashboard can grow new widgets
 * without ballooning the route file.
 */
export const Route = createFileRoute('/')({
  component: HomePage,
});

function HomePage() {
  return (
    <Stack gap={5}>
      <GreetingHeader />
      <NeedsAttention />
      <AccountCard />
      <QuickNav />
      <ApiStatusFooter />
    </Stack>
  );
}
